import { SingleOrArray } from "@dirootie-extensions/typescript";
import { normalizePath } from "../paths";
import { propOrPath } from "./props";
import { complement, has, isEmpty, isNil, pathSatisfies, all } from 'ramda';

export const hasPropOrPath = (path: SingleOrArray<string>) =>
  pathSatisfies(complement(isNil), normalizePath(path));

export const isEmptyProp = <T>(propName: string, obj: T) =>
  hasPropOrPath(propName)(obj) && isEmpty(propOrPath<T>(propName)(obj));

export const isNotEmptyProp = <T>(propName: string, obj: T) =>
  !isEmptyProp(propName, obj);

export const hasAnyProp = <T>(propNames: string[]) => ( obj: T) => {
  const result = propNames.some((x) => hasPropOrPath(x)(obj));
  return result;
}

export const hasNoneProp = complement(hasAnyProp);

export const hasAllProp = <T>(propNames: string[], obj: T) => {
  const result = all((x) => hasPropOrPath(x)(obj),propNames);
  return result;
}
